import { render, staticRenderFns } from "./AdminPodGames.vue?vue&type=template&id=10e36c91&scoped=true&"
import script from "./AdminPodGames.vue?vue&type=script&lang=js&"
export * from "./AdminPodGames.vue?vue&type=script&lang=js&"
import style0 from "./AdminPodGames.vue?vue&type=style&index=0&id=10e36c91&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e36c91",
  null
  
)

export default component.exports